/*
 * LXRYWOOD Landing Page — Scroll-Animations Bootstrap
 *
 * Rein IntersectionObserver + rAF basiert. Kein Three.js, kein esm.sh,
 * kein CDN — funktioniert im Shopify Theme Editor Preview, auf Mobile
 * und bei strikter CSP.
 *
 * Features:
 *   1. .lxry-lp__reveal Fade-Up (IO-triggered)
 *   2. .lxry-lp-pain__item Slide-In-From-Left
 *   3. [data-lxry-counter] Zaehler-Animation
 *   4. Hero headline Fade-In
 *   5. Assembly Fallback (.is-playing / .is-rotating) — falls die alte
 *      Assembly-Section noch im Template liegt
 *   6. Mounting-Phase Scroll-Progress
 */
(function () {
  'use strict';

  if (window.__lxryLp3dBooted) return;
  window.__lxryLp3dBooted = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ARMED-Flag: Content ist per Default sichtbar. Erst wenn JS verfuegbar
     ist und IntersectionObserver unterstuetzt wird, aktivieren wir die
     CSS-Regel die opacity: 0 setzt. Somit bleibt Content bei JS-Fehlern
     oder fehlendem IO immer lesbar. */
  function armReveal() {
    if (!('IntersectionObserver' in window) || reduceMotion) return;
    document.documentElement.classList.add('lxry-lp__reveal--armed');
  }

  // --- Reveal: .lxry-lp__reveal → .is-in ---
  function revealAll() {
    var els = document.querySelectorAll('.lxry-lp__reveal');
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  // --- Pain-Items Reveal ---
  function revealPainItems() {
    var items = document.querySelectorAll('.lxry-lp-pain__item');
    if (!items.length || !('IntersectionObserver' in window) || reduceMotion) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0.1 });
    items.forEach(function (el) { io.observe(el); });
  }

  // --- Counter-Animation: [data-lxry-counter] ---
  function runCounters() {
    var els = document.querySelectorAll('[data-lxry-counter]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-lxry-counter')) || 0;
        var suffix = el.getAttribute('data-lxry-counter-suffix') || '';
        if (target === 0) return;
        var duration = 1400;
        var t0 = performance.now();
        function tick(now) {
          var p = Math.min(1, (now - t0) / duration);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased).toLocaleString('de-DE') + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  // --- Mounting-Phase Scroll-Progress ---
  function wireMounting() {
    var section = document.querySelector('[data-lxry-mounting-section]');
    if (!section) return;
    var ticking = false;
    function update() {
      ticking = false;
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var total = rect.height - vh;
      if (total <= 0) return;
      var scrolled = -rect.top;
      var p = Math.max(0, Math.min(1, scrolled / total));
      var phase = 1;
      if (p >= 0.33) phase = 2;
      if (p >= 0.66) phase = 3;
      if (section.getAttribute('data-lxry-mounting-phase') !== String(phase)) {
        section.setAttribute('data-lxry-mounting-phase', String(phase));
      }
    }
    function onScroll() {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  // --- Assembly Fallback (legacy, IO-only) ---
  function wireAssemblyFallback() {
    var section = document.querySelector('[data-lxry-assembly-section]');
    if (!section) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      section.classList.add('is-playing', 'is-rotating');
      return;
    }
    var playIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !section.classList.contains('is-playing')) {
          section.classList.add('is-playing');
          setTimeout(function () { section.classList.add('is-rotating'); }, 2400);
          playIO.unobserve(section);
        }
      });
    }, { threshold: 0.15 });
    playIO.observe(section);
  }

  // Reduced-Motion: alles sofort sichtbar
  if (reduceMotion) {
    document.documentElement.classList.add('lxry-reduce-motion');
    document.querySelectorAll('.lxry-lp__reveal, .lxry-lp-pain__item').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  // Boot
  function boot() {
    armReveal();
    revealAll();
    revealPainItems();
    runCounters();
    wireMounting();
    wireAssemblyFallback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
